import { Component, Injectable, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { CommonService } from 'src/app/_services/common.service';
import { VendorService } from 'src/app/_services/vendor.service';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-confirm-new-vendor',
  templateUrl: './confirm-new-vendor.component.html',
  styleUrls: ['./confirm-new-vendor.component.css']
})
export class ConfirmNewVendorComponent implements OnInit {
  receivedId: number;

  constructor(public dialogRef: MatDialogRef<ConfirmNewVendorComponent>,
    private alertService: AlertService,
    private authService: AuthService,
    public vendorService : VendorService,
    public commonService : CommonService,
    private router: Router) {
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.commonService.triggerGridRefresh();
  }

  onClick() {
    this.receivedId = this.authService.getId();
    console.log(this.receivedId);
    this.router.navigate(['/All/editVendor', this.receivedId]);
  }

}
